<template>
  <div id="RestoreBatchPlants">
    <vs-popup id="RestoreBatchPlants" class="text-center" title="Restore Batch Plants" :active.sync="isActive">
      <form>
        <div class="vx-row mt-3">
          <div class="vx-col w-1/2">
            <div class="weight_details border-4 border-solid border-grey-light p-4 h-full">
              <!-- select destroy date -->
              <div class="mt-5 text-left">
                <label>Date</label>
                <date-picker :appendToBody="false" v-model="restore_date" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" valueType="format" class="w-full" name="date" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
              </div>

              <!-- destroy reason -->
              <div class="mt-5 text-left">
                <label>Reason</label>
                <vs-input type="text" class="w-full text-left" name="reason" placeholder="Enter Reason" v-model="restore_reason" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
              </div>

              <!-- filter for current plant -->
              <div class="mt-10 text-left">
                <label>Search by Serial Number</label>
                <div class="relative">
                  <vs-input type="text" class="w-full text-left" name="batch_name" placeholder="Search" v-model="filters.search" />
                  <div class="absolute Serch-icon">
                    <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-4 gap-5 items-end">
                <!-- batch name -->
                <div class="mt-5 text-left col-span-2">
                  <label for="batchName">Batch Name</label>
                  <select-2
                    class="w-full mb-1"
                    :value="filters.batchId"
                    @input="
                      (item) => {
                        filters.batchId = item && item.value
                      }
                    "
                    name="Batch name"
                    autocomplete
                    placeholder="Select Batch Name"
                    @scrollEnd="fetchNextBatches"
                    :clearable="false"
                    :options="batchOptions"
                  />
                </div>

                <!-- plant name -->
                <div class="mt-5 text-left">
                  <label for="plantName">Strain Name</label>
                  <select-2
                    class="w-full mb-1"
                    :value="filters.plant_name"
                    @input="
                      (item) => {
                        filters.plant_name = item && item.value
                      }
                    "
                    name="Strain name"
                    autocomplete
                    placeholder="Select Strain Name"
                    :options="plantNameOptions"
                  />
                </div>

                <!-- clear filter btn -->
                <div class="filter_reset mt-6 text-left">
                  <vs-button class="mt-4 mb-1" color="danger" type="relief" @click="clearFilter">Clear Filter</vs-button>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col w-1/2">
            <div class="weight_details border-4 border-solid border-grey-light p-4 h-full">
              <!-- number of plant counted -->
              <div class="num__selected_plants text-center mb-5">
                {{ restorePlantStat && restorePlants.length ? selectedPlantCount : restorePlants.length }} plants selected from {{ totalPlants }} plants
              </div>

              <!-- plant list -->
              <div id="restore_plant__list_container" class="plants flex-grow border-0 border-b-2 border-solid border-grey-light py-5 px-2 table-height">
                <vs-table
                  v-model="restorePlants"
                  multiple
                  id="destroy_plant__list"
                  class="vs-con-loading__container mb-5 table-overflow"
                  stripe
                  :data="plantListOptions"
                  @selected="handleChangeRecord"
                >
                  <template slot="thead">
                    <vs-th>Strain </vs-th>
                    <vs-th>Serial Number</vs-th>
                    <vs-th>Stage</vs-th>
                    <vs-th>Location Name</vs-th>
                  </template>

                  <template slot-scope="{ data }" ref="tableBody">
                    <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                      <vs-td>{{ tr.plant_name }}</vs-td>
                      <vs-td> {{ tr.serialNumber }} </vs-td>
                      <vs-td>{{ renderPlantStage(tr.plant_stage) || 'Immature' }}</vs-td>
                      <vs-td>{{ tr.location && tr.location.name }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>

          <div class="vx-col mt-5 ml-auto">
            <vs-button class="mr-5" color="primary" type="relief" @click="restoreMultiplePlantsConfirmation">Save</vs-button>
            <vs-button @click="isActive = false" color="danger" type="relief">Close</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { weightTypes } from '@/utils/weightType'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { backgrondScrollHandler } from '@/utils/functions'
import { plantStages } from '@/utils/batch-options'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'RestoreBatchPlants',

  components: {
    DatePicker,
    Select2,
    VuePerfectScrollbar
  },

  props: {
    isModalShow: Boolean,
    batchId: {
      type: Number,
      default: null
    },
    isArchievedList: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      weightTypeOptions: weightTypes.filter((x) => x.type === 'WeightBased'),
      dateFormat: 'MM-dd-yyyy',
      restore_date: moment().format('MM-DD-YYYY'),
      restore_reason: null,

      // filters
      batchOptions: [],
      filters: {
        search: null,
        batchId: null,
        plant_name: null
      },

      // destroy plants
      page: 1,
      limit: 0,
      search: null,
      plantStages: ['destroyed', 'sold'],
      totalPlants: 0,
      plantList: [],
      restorePlants: [],
      excludedPlants: [],
      restorePlantStat: null,

      // batch
      batchFilters: {
        page: 1,
        length: 0,
        order: [],
        search: null,
        totalBatch: 0
      }
    }
  },

  mounted() {
    if (this.batchId) this.filters.batchId = this.batchId

    // handle backgrond scroll
    backgrondScrollHandler(true)

    // get batch list
    this.getBatchList()
  },

  computed: {
    ...mapState('batch', { batchPlantGroupByName: 'batchPlantGroupByName' }),
    isActive: {
      get() {
        return this.isModalShow
      },
      set(val) {
        // handle backgrond scroll
        backgrondScrollHandler(false)
        this.$emit('update:isModalShow', val)
      }
    },

    // plant name options
    plantNameOptions() {
      return [...new Set(this.batchPlantGroupByName.map((item) => item.plant_name))].map((x) => {
        return {
          label: x,
          value: x
        }
      })
    },

    // plant list options
    plantListOptions() {
      // filter by serial number
      return this.filters.search ? this.plantList.filter((x) => x.serialNumber.search(this.filters.search) > -1) : this.plantList
    },

    renderPlantStage() {
      return (plantStage) => {
        return (plantStages.find((x) => x.value === plantStage) || {}).label
      }
    },

    selectedPlantCount() {
      return this.totalPlants - this.excludedPlants.length || 0
    }
  },

  methods: {
    // get batch plants
    getBatchPlants() {
      this.loading = true
      this.$store
        .dispatch('batch/getBatchPlants', {
          id: this.filters.batchId,
          list: 'plant',
          data: {
            page: this.page,
            limit: this.limit,
            search: this.search,
            plantStages: this.plantStages,
            filters: this.filters
          }
        })
        .then((res) => {
          this.totalPlants = res.FilteredCount
          this.plantList.push(...res.data)

          if (this.restorePlantStat) {
            res.data.forEach((x) => {
              if (!this.restorePlants.find((y) => y.id === x.id)) {
                this.restorePlants.push(x)
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // get batch list
    async getBatchList(page = this.batchFilters.page) {
      this.$store
        .dispatch('batch/getBatches', { page, limit: this.batchFilters.length, search: this.batchFilters.search, order: this.batchFilters.order })
        .then(({ data, FilteredCount }) => {
          this.batchFilters.totalBatch = FilteredCount

          this.batchOptions.push(
            ...data.reduce((acc, item) => {
              item.label = `${item.batch_number} - ${item.batch_name}`
              acc.push(item)

              return acc
            }, [])
          )
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // fetch next page of batch
    fetchNextBatches() {
      if (this.batchFilters.totalBatch > this.batchOptions.length) {
        this.fetchNextBatches(this.batchFilters.page + 1)
      }
    },

    // destroy batch plants - confirmation
    async restoreMultiplePlantsConfirmation() {
      if (!(await this.$validator.validate())) {
        return false
      }

      if (this.restorePlants.length < 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select at least one plant to restore',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Restore',
        text: 'Are you sure you want to restore this record?',
        accept: () => this.restoreMultiplePlants(),
        acceptText: 'Restore'
      })
    },

    restoreMultiplePlants() {
      this.loading = true
      this.$store
        .dispatch('batch/restoreBatchPlants', {
          restore_date: this.restore_date,
          restore_reason: this.restore_reason,
          restore_status: this.restorePlantStat,
          batchId: this.filters.batchId,
          plantIds: this.restorePlants.map((x) => x.id),
          unselectedPlantIds: this.excludedPlants
        })
        .then(({ message }) => {
          this.loading = false

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$emit('done')
          this.isActive = false
        })
        .catch(({ message }) => {
          this.loading = false

          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // clear filter
    clearFilter() {
      this.filters = {
        search: null,
        batchId: this.batchId,
        plant_name: null
      }
    },

    // handle scan serial number and auto select
    handleScanAndAutoSelect() {
      const scanedPlant = this.plantList.find((x) => x.serialNumber === this.filters.search)

      if (scanedPlant && !this.restorePlants.find((x) => x.serialNumber === this.filters.search)) {
        this.restorePlants.push(scanedPlant)
      }
    },

    // handle select all plants of batch
    handleSelectAllPlantOfBatch() {
      if (this.restorePlants.length > 0 && this.restorePlants.length === this.plantList.length && !this.restorePlantStat) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm Plant Selection',
          text: `There are ${this.totalPlants} plants in this batch. Are you sure you want to restore all plants of this batch or restore only selected plants?`,
          accept: () => {
            this.restorePlantStat = 'all'
          },
          acceptText: 'Select All',
          cancel: () => {
            this.restorePlantStat = 'limit'
          },
          cancelText: 'Selected Only'
        })
      }

      if (this.restorePlants.length === this.plantList.length) {
        this.excludedPlants = []
      }

      if (this.restorePlants.length < 1) {
        this.restorePlantStat = null
        this.excludedPlants = []
      }
    },

    // handle change record
    handleChangeRecord(tr) {
      if (!this.restorePlants.length) {
        this.excludedPlants = []
      }

      if (!this.restorePlants.find((x) => x.id === tr.id)) {
        this.excludedPlants.push(tr.id)
      } else {
        this.excludedPlants = this.excludedPlants.filter((x) => x !== tr.id)
      }
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#RestoreBatchPlants .vs-popup .vs-popup--content',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#RestoreBatchPlants .vs-popup .vs-popup--content > .con-vs-loading')
      }
    },

    'filters.batchId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.plantList = []
          this.plantPage = 1
          this.restorePlants = []
          this.getBatchPlants()
        }
      }
    },

    'filters.search': {
      handler() {
        this.handleScanAndAutoSelect()
      }
    },

    'filters.plant_name': {
      immediate: true,
      handler(newVal) {
        if (this.filters.batchId) {
          this.search = newVal
          this.plantList = []
          this.page = 1
          this.destroyPlants = []
          this.getBatchPlants()
        }
      }
    }
  }
}
</script>

<style lang="scss">
#RestoreBatchPlants {
  .vs-popup {
    width: calc(100% - 30%) !important;
    position: relative;

    .con-vs-loading {
      position: absolute;
    }

    .vdp-datepicker {
      position: unset;
    }
    .Serch-icon {
      top: 10px;
      right: 10px;
    }
    .table-height {
      max-height: 400px;
      overflow: auto;

      .vs-con-table {
        min-width: 600px;
      }

      .con-tablex {
        width: auto;
        overflow: visible;

        .vs-con-tbody {
          width: auto;
          overflow: visible;
        }
      }
    }

    tr {
      text-align: left;
    }
  }
  .ps__scrollbar-y-rail {
    z-index: 9999;
    .ps__scrollbar-y {
      width: 10px;
    }
  }
  .ps__scrollbar-x-rail {
    z-index: 9999;
    .ps__scrollbar-x {
      width: 10px;
    }
  }
}
</style>
